import { Reference } from "@/services/backend/documents/types/reference-number";
import { DocumentStateBase } from "@/services/backend/documents/types/state";
import { Artefact, Document } from "@bitory-gmbh/bsm";
import { Address } from "@/services/backend/addresses/types/address";
import { Contact } from "@/services/backend/contacts/types/contact";
import { Representative } from "@/services/backend/representatives/types/representative";
import { Common } from "@/services/backend/documents/types/common";

export interface Order
  extends Document, Artefact, DocumentStateBase, Common, Reference {
  offerId: string;
  treatmentId: string;
  calculationId: string;
  date: string;
  channel: string;
  customerReference: string;
  internalComment: string;
  postalAddress: Address;
  serviceAddress: Address;
  serviceContact: Contact;
  representative: Representative;
}

export enum Channel {
  EMAIL = "email",
  PHONE = "phone",
  POST = "post",
  FAX = "fax",
}
